import { Koppelingen } from '../translations-types';

const translations: Koppelingen = {
  selectSalon: 'Branch',
  selectSalonPlaceholder: 'Choose a branch',
  saved: 'Saved',
  googleCalendarOption: 'Google Calendar (Salonized)',
  goBookyOption: 'Google Calendar (GoBooky)',
  salonizedDeprecatedOption: 'Salonized (being phased out)',
  leaveSalonizedTitle: 'Switch away from Salonized?',
  leaveSalonizedContent:
    'The Salonized coupling is being phased out. Switching disconnects Salonized and you cannot choose this coupling again afterwards. Then sync the new coupling, so the voorzorg/nazorg status and advice of the appointments are carried over.',
};

export default translations;
